module.exports = __webpack_public_path__ + "static/img/SOUS-MAINS-PURE-ZONE-CARTE-MONDE-40x60.8ea4d58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/produits/SOUS-MAINS-PURE-ZONE-CARTE-MONDE-40x60.jpg
// module id = JnYu
// module chunks = 0